<template>
  <div class="tickets-view">
    <site-menu theme="dark" class="menu"/>
    <div class="inner">
      <div class="content">
        <div class="all-access">
          <card
            color="green"
            :data="allAccessData"
            class="card"
            @click.native="checkout()"
          />
        </div>
        <!-- <div class="cards">
          <card
            v-for="card, i in cards"
            :color="i % 2 ? 'green' : 'yellow'"
            :data="card"
            class="card"
          />
        </div> -->
      </div>
      <divider />
      <div class="banner">
        <img src="../assets/packages-banner.jpg" />
        <div class="overlay">
          <p class="white">Join</p>
          <p class="yellow">The Voices of Change</p>
          <p class="white">In Capitol Hill</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SiteMenu from '@/components/SiteMenu.vue'
  import Divider from '@/components/Divider.vue'
  import RegisterButton from '@/components/RegisterButton.vue'
  import Card from '@/components/Card.vue'
  import packages from '@/lib/packages'

  export default {
    name: 'tickets-view',
    components: { SiteMenu, Divider, RegisterButton, Card },
    data() {
      return {
        allAccessData: packages[0],
        cards: packages.slice(1),
      }
    },
    methods: {
      checkout() {
        $router.push('/checkout')
        // location.href="https://wannago.show/www/wa/instance?id=50&k=aocgp1wsor4wy059udrw80cgw3a5jb&e=WNGInstance"
      },
    },
  }
</script>
<style scoped lang="scss">
  .tickets-view {
    position: relative;
    .content {
      padding-top: 30px;
    }
  }
  p {
    margin: 0;
    line-height: 1.2;
  }
  .banner {
    position: relative;
    padding-top: 3px;
    margin-bottom: -25px;
    img {
      width: 100%;
    }
    .overlay {
      position: absolute;
      right: 20px;
      text-align: right;
      top: 100px;
      font-size: 48px;
      color: #fff;
      font-weight: bold;
      text-transform: uppercase;
      p {
        &.yellow {
          color: $color-5;
        }
      }
    }
  }
  .cta, .intro {
    text-align: center;
  }
  .pre-registration {
    color: $color-1;
    font-size: 25px;
  }
  .intro {
    line-height: 1.4;
    font-size: 18px;
    opacity: 0.8;
    width: 600px;
    margin: 20px auto;
  }
  .card {
    cursor: pointer;
    &:hover {
      background-color: $color-3;
      color: #fff;
    }
  }
  @media (max-width: 500px) {
    .banner {
      padding-top: 50px;
      .overlay {
        font-size: 20px;
      }
    }
    .pre-registration {
      font-size: 20px;
      padding: 0 20px;
    }
    .intro {
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  @media (min-width: 501px) {
    .all-access {
      .card {
        width: 600px;
        margin: 0 auto;
      }
      padding-bottom: 5px;
    }
    .cards {
      overflow: hidden;
      .card {
        box-sizing: border-box;
        width: calc(33% - 10px);
        float: left;
        height: 230px;
      }
    }
  }
</style>